import { DatePipe } from "@angular/common";
import { Inject, LOCALE_ID, Pipe, PipeTransform } from "@angular/core";
import * as moment from "moment";

@Pipe({
    name: "cetDate",
    standalone: false
})
export class CetDatePipe implements PipeTransform {
    constructor(private datePipe: DatePipe) { }

    /**
     * Returns the date in ISO format - <b>2019-01-01 12:34:56</b>
     */
    transform(value: Date | string | number, format?: string | undefined): string | null;
    transform(value: null | undefined, format?: string | undefined): null;
    transform(value: Date | string | number | null | undefined, format?: string | undefined): string | null;
    transform(value: Date | string | number | null | undefined, format?: string | undefined): string | null {
        let offset: string | undefined;

        if (value) {
            const dateValue = new Date(value);

            offset = this.getTimezoneOffset(dateValue, 'Europe/Zurich');
        }

        return this.datePipe.transform(value, format, offset);
    }

    private getTimezoneOffset(d, tz): string {
        d = new Date(d || Date.now());
        d.setMilliseconds(0); // for nice rounding

        const
            hereOffsetHrs = d.getTimezoneOffset() / 60 * -1,
            thereLocaleStr = d.toLocaleString('en-US', { timeZone: tz }),
            thereDate = new Date(thereLocaleStr),
            diffHrs = (thereDate.getTime() - d.getTime()) / 1000 / 60 / 60,
            thereOffsetHrs = hereOffsetHrs + diffHrs;

        let offset = thereOffsetHrs.toString();
        if (!offset.startsWith('-')) {
            offset = '+' + offset;
        }

        return offset;
    }
}